import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import React from "react";

import Loading from "../state-pages/Loading";
import { Button } from "../ui/button";

import TableSkeleton from "./skeleton/TableSkeleton";

export type TFetchWrapperProps = {
  children: React.ReactNode;
  isLoading: boolean;
  isError: boolean;
  error?: FetchBaseQueryError | SerializedError;
  refetch?: () => void;
  loaderComp?: React.ReactNode;
  errorComp?: React.ReactNode;
  isTable?: boolean;
};

const FetchWrapper: React.FC<TFetchWrapperProps> = ({
  isError,
  isLoading,
  // eslint-disable-next-line no-empty-function
  refetch = (): void => {},
  children,
  loaderComp,
  errorComp,
  isTable = false,
}) => {
  if (isLoading) {
    if (isTable) {
      return <TableSkeleton />;
    }

    return loaderComp || <Loading />;
  }

  if (isError) {
    return (
      errorComp || (
        <div>
          Something went wrong
          <Button variant={"link"} onClick={refetch}>
            Retry
          </Button>
        </div>
      )
    );
  }

  return children;
};

export default FetchWrapper;
